import { createContext } from 'react';

import type { ApiRegistry } from '@/api/provider';

export const ApiContext = createContext<ApiRegistry | null>(null);
